import pegasus from "./01-pegasus";

document.addEventListener("DOMContentLoaded", function () {
    pegasus.decodeAllCloudflareEmails();
});
